<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<circle id="liveActiveOuterCircle" cx="12" cy="12" r="4" fill="#F5F7F8"/>
	<circle id="liveActiveInnerCircle" opacity="0.25" cx="12" cy="12" r="10" fill="#F5F7F8"/>
	</svg>
	